import { render, staticRenderFns } from "./Cybercoin.vue?vue&type=template&id=1c41606a&scoped=true"
import script from "./Cybercoin.vue?vue&type=script&lang=ts"
export * from "./Cybercoin.vue?vue&type=script&lang=ts"
import style0 from "./Cybercoin.vue?vue&type=style&index=0&id=1c41606a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c41606a",
  null
  
)

export default component.exports